const COOKIE_DOMAIN = '.relo.mx';

function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name: string, value: string, days = 365): void {
  if (typeof document === 'undefined') return;
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; domain=${COOKIE_DOMAIN}; path=/; expires=${expires}; SameSite=Lax; Secure`;
}

function removeCookie(name: string): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=; domain=${COOKIE_DOMAIN}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax; Secure`;
}

/**
 * Storage adapter that keeps localStorage as the primary source (so existing
 * portal sessions keep working) but also mirrors reads/writes to a
 * cross-domain cookie. That lets docs.relo.mx read the session without
 * changing the portal's main auth behavior.
 */
export const sharedStorage = {
  getItem: (key: string): string | null => {
    try {
      const local = localStorage.getItem(key);
      if (local) return local;
    } catch {}
    return getCookie(key);
  },
  setItem: (key: string, value: string): void => {
    try {
      localStorage.setItem(key, value);
    } catch {}
    setCookie(key, value);
  },
  removeItem: (key: string): void => {
    try {
      localStorage.removeItem(key);
    } catch {}
    removeCookie(key);
  },
};
